"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var dotsLoader_1 = __importDefault(require("./dotsLoader"));
var Typography_1 = __importDefault(require("../Typography"));
var react_1 = __importDefault(require("react"));
var MIN = 0;
var MAX = 100;
// Function to normalise the values (MIN / MAX could be integrated)
var normalise = function (percent) {
    if (percent > MAX)
        return MAX;
    if (percent < MIN)
        return MIN;
    return Math.round(((percent - MIN) * 100) / (MAX - MIN));
};
var loadingWrapperProps = ['loading', 'label'];
var LoadingWrapper = (0, material_1.styled)('div', {
    shouldForwardProp: function (prop) { return !loadingWrapperProps.includes(prop.toString()); },
})(function (_a) {
    var _b = _a.height, height = _b === void 0 ? '15vh' : _b, label = _a.label, loading = _a.loading;
    return ({
        display: loading ? 'flex' : 'none',
        flexDirection: label ? 'column' : 'row',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        height: height,
    });
});
var Percent = (0, material_1.styled)('div')(function () { return ({
    position: 'relative',
    minWidth: 45,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}); });
var Label = (0, material_1.styled)('div')({
    marginTop: 5,
});
var Loader = function (_a) {
    var size = _a.size, percent = _a.percent, label = _a.label, color = _a.color, onClick = _a.onClick, _b = _a.loading, loading = _b === void 0 ? false : _b, _c = _a.type, type = _c === void 0 ? 'dots' : _c, _d = _a.adminColor, adminColor = _d === void 0 ? false : _d, props = __rest(_a, ["size", "percent", "label", "color", "onClick", "loading", "type", "adminColor"]);
    return (react_1.default.createElement(LoadingWrapper, __assign({}, props, { label: label, loading: loading, type: type, percent: percent, "data-testid": "loading-element" }),
        type === 'dots' && react_1.default.createElement(dotsLoader_1.default, { color: adminColor ? 'blue' : color }),
        percent && (react_1.default.createElement(Percent, { type: type },
            react_1.default.createElement(Typography_1.default, { variant: "caption", color: "textSecondary" }, "".concat(normalise(percent), "%")))),
        label && (react_1.default.createElement(Label, null,
            react_1.default.createElement(Typography_1.default, { variant: "caption", color: "textSecondary" }, label)))));
};
exports.default = Loader;
//# sourceMappingURL=index.js.map